import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment'
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  public loaderSubject: any = new BehaviorSubject(false);
  constructor(
    private http: HttpClient,
    private toastService: ToastrService
  ) { }

    // -----------------------------------------------------------------------------------------------//
    //Backend API URL
    private baseURL = environment.backendApiUrl;
    // -----------------------------------------------------------------------------------------------//
  
    // AUTH SECTION
    private loginURL = `${this.baseURL}/auth`

    getLoginDetails(username?: any, access_token?:string, redirect_uri?: string, node?: string, env?: string): Observable<any>{
      const payload = {username, access_token, redirect_uri, node, env}
      return this.http.post<any>(`${this.loginURL}/login`,payload)
    }

    appLogOut(id: any):Observable<any>{
      return this.http.post<any>(`${this.loginURL}/logout`,id)
    }
  }
